// Lightweight client-side logger wrapper
// Provides debug/info/warn/error with simple redaction and level control
const { REDACTED, isCredentialKey, redactCredentials } = require('./redactCredentials');

const LEVELS = {
  debug: 0, info: 1, warn: 2, error: 3,
};
const envLevel = (typeof window !== 'undefined' && window.__ENV && window.__ENV.REACT_APP_LOG_LEVEL)
  || 'info';
const currentLevel = LEVELS[envLevel] != null ? LEVELS[envLevel] : LEVELS.info;

function redactValue(value) {
  if (value == null) return value;
  const s = String(value);
  if (s.length <= 4) return '****';
  return `${s.slice(0, 2)}****${s.slice(-2)}`;
}

function redactObject(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  const safe = {};
  const keysToRedact = ['ssn', 'dob', 'email', 'phoneNumber', 'accessToken', 'idToken', 'refreshToken', 'password', 'secret', 'creditCard'];
  const headerLikeKeys = ['authorization', 'cookie'];
  Object.keys(obj).forEach(k => {
    try {
      const lower = k.toLowerCase();
      if (isCredentialKey(k)) {
        safe[k] = REDACTED;
      } else if (keysToRedact.includes(k) || lower.includes('token')) {
        safe[k] = redactValue(obj[k]);
      } else if (headerLikeKeys.includes(lower)) {
        safe[k] = redactValue(obj[k]);
      } else if (typeof obj[k] === 'object') {
        safe[k] = redactObject(obj[k]);
      } else {
        safe[k] = obj[k];
      }
    } catch (e) {
      safe[k] = '****';
    }
  });
  return safe;
}

function sanitizeForSingleLine(obj) {
  try {
    if (obj == null) return obj;
    if (typeof obj === 'string') return obj.replace(/\r?\n/g, '\\n');
    if (typeof obj !== 'object') return obj;
    const out = Array.isArray(obj) ? [] : {};
    Object.keys(obj).forEach(k => {
      try {
        const v = obj[k];
        if (typeof v === 'string') out[k] = v.replace(/\r?\n/g, '\\n');
        else if (v && typeof v === 'object') out[k] = sanitizeForSingleLine(v);
        else out[k] = v;
      } catch (e) {
        out[k] = String(obj[k]).replace(/\r?\n/g, '\\n');
      }
    });
    return out;
  } catch (e) {
    return obj;
  }
}

function log(level, metaOrMessage, maybeMessage) {
  const l = LEVELS[level];
  if (l == null || l < currentLevel) return;
  try {
    if (typeof metaOrMessage === 'string') {
      // ensure single-line
      // eslint-disable-next-line no-console
      console[level](redactCredentials(String(metaOrMessage)).replace(/\r?\n/g, '\\n'));
      return;
    }
    const meta = sanitizeForSingleLine(redactObject(redactCredentials(metaOrMessage || {})));
    const message = redactCredentials(String(maybeMessage || ''));
    // eslint-disable-next-line no-console
    const single = `${String(message).replace(/\r?\n/g, '\\n')} ${JSON.stringify(meta)}`;
    console[level](single);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Logger failure:', redactCredentials(e && e.message));
  }
}

module.exports = {
  debug: (meta, msg) => log('debug', meta, msg),
  info: (meta, msg) => log('info', meta, msg),
  warn: (meta, msg) => log('warn', meta, msg),
  error: (meta, msg) => log('error', meta, msg),
  redact: redactValue,
};

// Allow both CommonJS `require` and ESM `import default` consumers
exports.default = module.exports;
